import {
  useEffect,
  useState
} from "react";

import {
  Link,
  useNavigate
} from "react-router-dom";

import API from "../../services/api";
import { hasPermission } from "../../utils/permission";

function Expenses() {

  const navigate =
    useNavigate();

  const [expenses,
    setExpenses] =
    useState([]);

  const [search,
    setSearch] =
    useState("");

  const [page,
    setPage] =
    useState(1);

  const [pages,
    setPages] =
    useState(1);

  useEffect(() => {
    loadExpenses();
  }, [page, search]);

  const loadExpenses =
    async () => {

      try {

        const res =
          await API.get(
            `/expenses?page=${page}&search=${search}`
          );

        setExpenses(
          res.data.expenses
        );

        setPages(
          res.data.pages
        );

      } catch (err) {
        console.log(err);
      }

    };

  const deleteExpense =
    async (id) => {

      if (
        !window.confirm(
          "Delete Expense?"
        )
      ) return;

      try {

        await API.delete(
          `/expenses/${id}`
        );

        loadExpenses();

      } catch (err) {
        console.log(err);
      }

    };

  const totalExpense =
    expenses.reduce(
      (sum, item) =>
        sum +
        Number(item.amount),
      0
    );

  return (
    <div>

      <div
        className="
        flex
        flex-col
        md:flex-row
        justify-between
        gap-4
        mb-6
      "
      >

        <h1
          className="
          text-4xl
          font-bold
        "
        >
          Expenses
        </h1>

        {hasPermission("expense.add") && (
          <Link
            to="/admin/expenses/add"
            className="
          bg-yellow-500
          text-black
          px-5
          py-3
          rounded-xl
          font-semibold
        "
          >
            Add Expense
          </Link>
        )}



      </div>

      <div
        className="
        bg-[#111]
        rounded-2xl
        p-5
        mb-6
      "
      >
        <p>
          Total Expense
        </p>

        <h2
          className="
          text-4xl
          font-bold
          text-red-400
        "
        >
          ₹
          {totalExpense.toFixed(2)}
        </h2>
      </div>

      <input
        value={search}
        onChange={(e) =>
          setSearch(
            e.target.value
          )
        }
        placeholder="Search Expense..."
        className="
        w-full
        md:w-80
        p-3
        bg-[#111]
        rounded-xl
        mb-6
      "
      />

      <div
        className="
        bg-[#111]
        rounded-2xl
        overflow-hidden
      "
      >

        <div
          className="
          overflow-x-auto
        "
        >

          <table
            className="
            w-full
          "
          >

            <thead>

              <tr
                className="
                border-b
                border-yellow-500/20
              "
              >

                <th className="p-4 text-left">
                  Title
                </th>

                <th className="p-4 text-left">
                  Amount
                </th>

                <th className="p-4 text-left">
                  Date
                </th>

                <th className="p-4 text-left">
                  Note
                </th>

                <th className="p-4 text-left">
                  Action
                </th>

              </tr>

            </thead>

            <tbody>

              {expenses.map(
                (item) => (

                  <tr
                    key={item.id}
                    className="
                    border-b
                    border-yellow-500/10
                  "
                  >

                    <td className="p-4">
                      {item.title}
                    </td>

                    <td
                      className="
                      p-4
                      text-red-400
                      font-semibold
                    "
                    >
                      ₹
                      {item.amount}
                    </td>

                    <td className="p-4">
                      {
                        new Date(item.expense_date).toLocaleDateString()
                      }
                    </td>

                    <td className="p-4">
                      {item.note}
                    </td>

                    <td className="p-4">

                      <div
                        className="
                        flex
                        gap-2
                        "
                      >

                        {hasPermission("expense.edit") && (
                          <button
                            onClick={() =>
                              navigate(
                                `/admin/expenses/edit/${item.id}`
                              )
                            }
                            className="
                          px-4
                          py-2
                          bg-blue-500
                          rounded-lg
                          "
                          >
                            Edit
                          </button>
                        )}

                        {hasPermission("expense.delete") && (
                          <button
                            onClick={() =>
                              deleteExpense(
                                item.id
                              )
                            }
                            className="
                          px-4
                          py-2
                          bg-red-500
                          rounded-lg
                          "
                          >
                            Delete
                          </button>
                        )}

                      </div>

                    </td>

                  </tr>

                )
              )}

            </tbody>

          </table>

        </div>

      </div>

      <div
        className="
        flex
        gap-2
        mt-6
      "
      >

        {[...Array(pages)]
          .map(
            (_, i) => (

              <button
                key={i}
                onClick={() =>
                  setPage(
                    i + 1
                  )
                }
                className={`
                  px-4 py-2 rounded-lg
                  ${page === i + 1
                    ? "bg-yellow-500 text-black"
                    : "bg-[#111]"
                  }
                `}
              >
                {i + 1}
              </button>

            )
          )}

      </div>

    </div>
  );
}

export default Expenses;